/** @format */
import { useContext } from "react"

import { Pages } from "../../../../components/contentful"
import { PageTypes } from "../../../../components/contentful/page"
import { getPageContents } from "../../../../components/contentful/pageProps"
import { Context } from "../../../../context"
import { formatDMA } from "../../../../util"
import { API } from "../../../../util/api"
import { RenderMsoDmaPage } from ".."

const type = PageTypes.DMACollision

const DmaRepair = ({ content, dmaName, stores }) => {
    const { dispatch } = useContext(Context)

    return RenderMsoDmaPage({
        content,
        context: {
            dmaName: formatDMA(dmaName),
            msoName: null,
        },
        dispatch,
        name: dmaName,
        stores,
        type,
    })
}

export async function getStaticPaths() {
    return {
        paths: [], // don't pre-render path; all pages should be rendered on-demand
        fallback: "blocking", // render the page on first request
    }
}

export async function getStaticProps({ ...props }) {
    const {
        preview,
        params: { state: slug },
    } = props

    const lowercaseSlug = slug.toLowerCase()
    const dmaPages = await API.getDmaList(true)
    const matchingDmaPage = dmaPages.find(({ url }) => url === lowercaseSlug)

    const { name: dmaName, stores } = await API.getDmaStores({
        preview,
        dmaUri: slug,
    })

    return await getPageContents(
        { notFound: !dmaName, dmaName: matchingDmaPage.name, stores, ...props },
        Pages[type]
    )
}

export default DmaRepair
